<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              {{ $t('Paieška') }}
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-text-field
                  :label="$t('Dokumento numeris')"
                  v-model="extraData.pra_id"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  :label="$t('Unikalus numeris')"
                  v-model="extraData.turtas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="veiksmasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="false"
                  :label="$t('Veiksmas')"
                  v-model="extraData.veiksmas"
                />
              </v-col>
              <v-col cols="12" md="12">
                <el-autocomplete
                  :items="prasymasTipasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  :label="$t('Dokumento rūšis')"
                  v-model="extraData.pra_tipas"
                />
              </v-col>
              <v-col cols="12" md="12">
                <el-text-field label="Šalis" v-model="extraData.salis" />
              </v-col>

              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="busenaList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  :label="$t('Būsena')"
                  v-model="extraData.pra_busena"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  :label="$t('Būsenos data nuo')"
                  v-model="extraData.pra_busenos_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  :label="$t('Būsenos data iki')"
                  v-model="extraData.pra_busenos_data_iki"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button primary @click.native.stop="searchData()">
                  {{ $t('Ieškoti') }}
                </el-button>
                <el-button @click.native="clearData()">
                  {{ $t('Išvalyti') }}
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import NtrPaslaugosMap from './NtrPaslaugosMap'

export default {
  name: 'NtrDokumentaiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [userRole],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    prasymasTipasList: [],
    busenaList: [],
    veiksmasList: [],
    mainData: {},
    extraData: {
      pra_tipas: [],
    },
  }),
  computed: {
    ...mapGetters(['searchParams', 'savitarnaXid']),
    isExpanded() {
      return this.searchPanel === 0
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    if (this.searchParams && this.searchParams.route === this.$route.name) {
      this.mainData = this.searchParams.mainData
      this.extraData = this.searchParams.extraData
      this.searchPanel = this.searchParams.isExpanded ? 0 : null
    }

    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: [
          'prasymas_tipas',
          'prasymas_busena',
          'prasymas_veiksmas',
        ],
      }

      this.$axios
        .post(`ntrpaslaugos/klasifikatorius/list`, data)
        .then(res => {
          this.busenaList = res.data.list.prasymas_busena
          this.prasymasTipasList = res.data.list.prasymas_tipas
          this.veiksmasList = res.data.list.prasymas_veiksmas

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        xid: this.savitarnaXid,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        pra_tipas: [],
      }
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
